export default __webpack_public_path__ + "static/media/tech3.3594b7ea.png";